import { Pipe, PipeTransform } from '@angular/core';
import { ParticipationComponent } from '../participation/participation.component';
import { Questions } from '../common-class/questions';
import { Group } from '../common-class/pages';
import { EditResponseComponent } from '../edit-response/edit-response.component';
import { SurveyPreviewComponent } from '../survey-preview/survey-preview.component';

@Pipe({
  name: 'getgroup'
})
export class GroupPipe implements PipeTransform {

  constructor(private participation: ParticipationComponent) { }

  transform(question: Questions, args?: any): Group {
    return this.participation.GetGroupData(question.group_no);
  }
}

@Pipe({
  name: 'getgroupedit'
})
export class GroupPipeEdit implements PipeTransform {

  constructor(private editResponse: EditResponseComponent) { }

  transform(question: Questions, args?: any): Group {
    return this.editResponse.GetGroupData(question.group_no);
  }
}

@Pipe({
  name: 'getgrouppreview'
})
export class GroupPipePreview implements PipeTransform {

  constructor(private surveyPreview: SurveyPreviewComponent) { }

  transform(question: Questions, args?: any): Group {
    // Check for grid questions, Multiple Text Box, Attachment, and Signature questions
    if (question && (
      question.group_no || 
      question.qtype === 'GR' || 
      question.qtype === 'GC' || 
      question.qtype === 'SC' || 
      question.qtype === 'RW' ||
      (question.qtype === 'T' && question.qsubtype === 0 && question.group_no > 0) || // Multiple Text Box
      (question.qtype === 'T' && question.qsubtype === 71) || // Attachment
      (question.qtype === 'T' && question.qsubtype === 72)    // Signature
    )) {
      // Check if we have Groups data in the survey and a valid group_no
      if (question.group_no && question.group_no > 0) {
        const groupsData = this.surveyPreview.surveyData?.Groups;
        if (groupsData) {
          // Find the actual group data - now using Group class directly
          const actualGroup = groupsData.find(g => g.group_no === question.group_no);
          if (actualGroup) {
            // Return the Group object directly since it's already the right type
            return actualGroup;
          }
        }
      }
      
      // If no Groups data found, try to create group data from the question structure
      // This handles cases where the survey data doesn't have explicit Groups
      if (question.qtype === 'GR' || question.qtype === 'GC' || question.qtype === 'SC') {
        // Create a group structure based on the question type
        const defaultGroup = new Group();
        defaultGroup.group_no = question.group_no || 1;
        defaultGroup.gtitle = this.getGroupTitleFromQuestion(question);
        defaultGroup.PipeGTitle = '';
        defaultGroup.QuestionTip = '';
        defaultGroup.L_text = '';
        defaultGroup.H_text = '';
        defaultGroup.M_text = '';
        defaultGroup.M_Pos = 0;
        defaultGroup.Matrix_id = 1; // Default matrix ID for grid questions
        defaultGroup.colwidth = 0;
        defaultGroup.isAnchorReverse = false;
        defaultGroup.ShowDemoSubQno = false;
        defaultGroup.answer_style = -1; // Default answer style for grid questions
        defaultGroup.isOverAllStyleApplied = true;
        defaultGroup.pipeTitle = '';
        defaultGroup.mgTextboxHeight = 1;
        defaultGroup.IsScribbledSignature = false;
        defaultGroup.IsUploadImageSignature = false;
        defaultGroup.IsTypeSignature = false;
        
        return defaultGroup;
      } else if (question.qtype === 'T' && question.qsubtype === 0 && question.group_no > 0) {
        // Multiple Text Box question
        const defaultGroup = new Group();
        defaultGroup.group_no = question.group_no || 1;
        defaultGroup.gtitle = question.qtitle || 'Multiple Text Box';
        defaultGroup.PipeGTitle = '';
        defaultGroup.QuestionTip = '';
        defaultGroup.L_text = '';
        defaultGroup.H_text = '';
        defaultGroup.M_text = '';
        defaultGroup.M_Pos = 0;
        defaultGroup.Matrix_id = 1;
        defaultGroup.colwidth = 0;
        defaultGroup.isAnchorReverse = false;
        defaultGroup.ShowDemoSubQno = false;
        defaultGroup.answer_style = 0; // Text box answer style
        defaultGroup.isOverAllStyleApplied = true;
        defaultGroup.pipeTitle = '';
        defaultGroup.mgTextboxHeight = 1;
        defaultGroup.IsScribbledSignature = false;
        defaultGroup.IsUploadImageSignature = false;
        defaultGroup.IsTypeSignature = false;
        
        return defaultGroup;
      } else if (question.qtype === 'T' && question.qsubtype === 71) {
        // Attachment question
        const defaultGroup = new Group();
        defaultGroup.group_no = question.group_no || 1;
        defaultGroup.gtitle = question.qtitle || 'Attachment';
        defaultGroup.PipeGTitle = '';
        defaultGroup.QuestionTip = '';
        defaultGroup.L_text = '';
        defaultGroup.H_text = '';
        defaultGroup.M_text = '';
        defaultGroup.M_Pos = 0;
        defaultGroup.Matrix_id = 1;
        defaultGroup.colwidth = 0;
        defaultGroup.isAnchorReverse = false;
        defaultGroup.ShowDemoSubQno = false;
        defaultGroup.answer_style = 0; // Text box answer style
        defaultGroup.isOverAllStyleApplied = true;
        defaultGroup.pipeTitle = '';
        defaultGroup.mgTextboxHeight = 1;
        defaultGroup.IsScribbledSignature = false;
        defaultGroup.IsUploadImageSignature = false;
        defaultGroup.IsTypeSignature = false;
        
        return defaultGroup;
      } else if (question.qtype === 'T' && question.qsubtype === 72) {
        // Signature question
        const defaultGroup = new Group();
        defaultGroup.group_no = question.group_no || 1;
        defaultGroup.gtitle = question.qtitle || 'Signature';
        defaultGroup.PipeGTitle = '';
        defaultGroup.QuestionTip = '';
        defaultGroup.L_text = '';
        defaultGroup.H_text = '';
        defaultGroup.M_text = '';
        defaultGroup.M_Pos = 0;
        defaultGroup.Matrix_id = 1;
        defaultGroup.colwidth = 0;
        defaultGroup.isAnchorReverse = false;
        defaultGroup.ShowDemoSubQno = false;
        defaultGroup.answer_style = 0; // Text box answer style
        defaultGroup.isOverAllStyleApplied = true;
        defaultGroup.pipeTitle = '';
        defaultGroup.mgTextboxHeight = 1;
        defaultGroup.IsScribbledSignature = false;
        defaultGroup.IsUploadImageSignature = false;
        defaultGroup.IsTypeSignature = false;
        
        return defaultGroup;
      }
    }
    
    // Return default group structure if no actual data found
    const fallbackGroup = new Group();
    fallbackGroup.group_no = 1;
    fallbackGroup.gtitle = 'Default Group';
    fallbackGroup.PipeGTitle = '';
    fallbackGroup.QuestionTip = '';
    fallbackGroup.L_text = '';
    fallbackGroup.H_text = '';
    fallbackGroup.M_text = '';
    fallbackGroup.M_Pos = 0;
    fallbackGroup.Matrix_id = 1;
    fallbackGroup.colwidth = 0;
    fallbackGroup.isAnchorReverse = false;
    fallbackGroup.ShowDemoSubQno = false;
    fallbackGroup.answer_style = 0;
    fallbackGroup.isOverAllStyleApplied = false;
    fallbackGroup.pipeTitle = '';
    fallbackGroup.mgTextboxHeight = 0;
    fallbackGroup.IsScribbledSignature = false;
    fallbackGroup.IsUploadImageSignature = false;
    fallbackGroup.IsTypeSignature = false;
    
    return fallbackGroup;
  }

  /**
   * Get group title based on question type and structure
   */
  private getGroupTitleFromQuestion(question: Questions): string {
    if (question.qtype === 'GR') {
      return 'Grid Radio';
    } else if (question.qtype === 'GC') {
      return 'Grid Checkbox';
    } else if (question.qtype === 'SC') {
      return 'Single Choice Grid';
    } else if (question.qtype === 'RW') {
      return 'Matrix Grid';
    }
    return 'Grid Question';
  }
}
